import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { T } from 'helpers/i18n';
import { BackgroundImage } from 'elements';
class InputImage extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            image: this.props.value
        };
        this.handleImage = (event) => {
            console.log('FieldImage - handleImage');
            if (event.target.files && event.target.files.length > 0) {
                console.log('FieldImage - handleImage - if');
                event.persist();
                const file = event.target.files[0];
                const accept = this.props.accept || 'image/jpeg';
                console.log('FieldImag - handleImage - if - accept: ', accept);
                console.log('FieldImag - handleImage - if - file.type: ', file.type);
                if (file.type === accept) {
                    this.props.onChange(this.props.name, file, this.props.column);
                    const fileReader = new FileReader();
                    fileReader.onload = () => {
                        this.setState({ image: fileReader.result }); // as string porque uso readAsDataURL
                    };
                    fileReader.readAsDataURL(file);
                }
                else {
                    console.log('FieldImage - handleImage - if - else');
                }
            }
            else {
            }
        };
    }
    render() {
        console.log('FieldImage - render');
        const { name, footer, accept } = this.props;
        const { image } = this.state;
        return (React.createElement(Wrapper, null,
            React.createElement(Label, null, T(name)),
            React.createElement(BackgroundImage, { image: image },
                React.createElement(StyledInput, { type: "file", accept: accept ? accept : 'image/jpeg', onChange: this.handleImage })),
            React.createElement(StyledText, null, footer ? footer : T('imageProperties'))));
    }
}
export default InputImage;
const Wrapper = cxs('div')({
    maxWidth: '60%',
    margin: 'auto',
    [mediaQueries.desktop]: {
        maxWidth: Theme.common.size.maxWidth / 3 + 'px'
    }
});
const Label = cxs('p')({
    color: Theme.color.placeholder,
    textAlign: 'center'
});
const StyledInput = cxs('input')({
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    opacity: 0,
    cursor: 'pointer'
});
const StyledText = cxs('div')({
    textTransform: 'none',
    textAlign: 'center',
    fontSize: Theme.fontSize.small,
    color: Theme.color.placeholder,
    padding: `${Theme.size.space[1]} 0 ${Theme.size.space[2]}`
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/FieldImage.tsx
// module id = 377
// module chunks = 0